module.exports = __webpack_public_path__ + "static/media/check-white.31d3f5a6.svg";